import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import defaultTagInput from 'src/examples/TagInput/default';
import variant1TagInput from 'src/examples/TagInput/variant-1';
import variant2TagInput from 'src/examples/TagInput/variant-2';
import widthButtonTagInput from 'src/examples/TagInput/widthButton';
import widthButton2TagInput from 'src/examples/TagInput/widthButton-2';
import * as React from 'react';
export default {
  graphql,
  ComponentApi,
  CodeView,
  defaultTagInput,
  variant1TagInput,
  variant2TagInput,
  widthButtonTagInput,
  widthButton2TagInput,
  React
};